import { makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles((theme) => ({
    titleWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(1, 1, 1, 4),
        backgroundColor: 'rgb(251, 251, 251)'
    },
    licenseTitle: {
        fontSize: 25,
        fontWeight: 700,
        color: 'rgb(0, 0, 0)',
        alignSelf: 'center',
    },
    addLicenceButtonsWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: theme.spacing(0, 0.5)
    },
    addLicenceButton: {
        display: 'flex',
        alignItems: 'center',
        borderStyle: 'solid',
        border: '2px',
        borderColor: 'rgb(255, 213, 0)',
        borderRadius: '25px',
        padding: theme.spacing(0.5, 1, 0.5, 1),
    },
    addLicenceLabel: {
        fontSize: 20,
        fontWeight: 500,
        color: 'rgb(255, 213, 0)',
        alignItems: 'center',
        marginTop: '4px',
        cursor: 'pointer'
    },
    closeButton: {
        marginLeft: theme.spacing(1),
        color: theme.palette.grey[500],
        alignSelf: 'center',
        cursor: 'pointer'
    },
    dialogWrapper: {
        padding: theme.spacing(4),
    },
    dialogContentWrapper: {
        padding: theme.spacing(0, 3, 3, 3),
        overflowY: "visible"
    },
    dialogActionWrapper: {
        padding: theme.spacing(0, 5, 5, 5),
    },
    headingsWrapper: {
        width: '60%',
        display: 'flex',
        padding: theme.spacing(1, 1, 0, 2.5),
    },
    headingText: {
        fontSize: 14,
        color: 'rgb(153, 164, 184)',
        fontWeight: 500,
    },
    mainContent: {
        // display: 'flex',
        height: '400px',
        justifyContent: "right"
    },
    leftPanel: {
        width: '60%',
        padding: theme.spacing(1, 0, 1, 1),
        float: 'left'
    },
    rightPanel: {
        // width: '40%',
        padding: theme.spacing(2, 1, 1, 3),
        // backgroundColor: 'rgb(251, 251, 251)'
    },
    licenseItem: {
        display: 'flex',
        height: theme.spacing(8),
        // padding: theme.spacing(0, 0, 1.5, 0),
        alignItems: 'center',
    },
    licenseNoBlock: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'flex-start',
        width: '40%',
    },
    licenseNoBlockWithoutTag: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '40%',
    },
    licenseNoBlockWithMultipleTag: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        alignSelf: 'flex-start',
        width: '40%',
    },
    defaultTag: {
        height: theme.spacing(2),
        fontSize: 10,
        margin: theme.spacing(0.5, 1, 0.75, 0),
        padding: theme.spacing(0.125, 1, 0, 1),
        backgroundColor: "rgb(255, 211, 40)",
        borderRadius: '10px',
        color: "rgb(255, 255, 255)",
    },
    expiredTag: {
        height: theme.spacing(2),
        fontSize: 10,
        margin: theme.spacing(0.5, 0, 0.75, 0),
        padding: theme.spacing(0.125, 1, 0, 1),
        backgroundColor: "rgb(255, 220, 205)",
        borderRadius: '10px',
        color: "rgb(209, 1, 1) !important",
    },
    licenceNumberText: {
        fontSize: 14,
        color: 'rgb(0, 0, 0)',
        fontWeight: 500,
        width: '90%',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    expiredLicenceNumberText: {
        fontSize: 14,
        color: '#7a7676',
        fontWeight: 500,
        width: '100%'
    },
    licenceContent: {
        fontSize: 14,
        color: 'rgb(0, 0, 0)',
        fontWeight: 500,
        alignSelf: 'flex-end'
    },
    expiredLicenseContent: {
        fontSize: 14,
        color: '#7a7676',
        fontWeight: 500,
        alignSelf: 'flex-end'
    },
    licenceLabel: {
        fontSize: 20,
        fontWeight: 500,
        background: '#d4d4d4',
        height: '64px',
        color: 'black',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '24px'
    },
    userInput: {
        margin: theme.spacing(1, 0, 2.5, 0),
        "& .MuiInputLabel-root": {
            transform: "translate(0, 1.5px) scale(1)",
            fontSize: 15,
            fontWeight: 400,
            color: "#000",
        },
        "& .MuiInputBase-root": {
            height: 50,
        },
        "& .MuiInputBase-input": {
            padding: `14px 10px`,
            color: 'rgb(152, 152, 152)'
        },
    },
    userInputPoints: {
        margin: theme.spacing(1, 0, 2.5, 0),
        "& .MuiInputLabel-root": {
            transform: "translate(0, 1.5px) scale(1)",
            fontSize: 15,
            fontWeight: 400,
            color: "#000",
        },
        "& .MuiInputBase-root": {
            height: 50,
        },
        "& .MuiInputBase-input": {
            padding: `14px 10px`,
            color: 'rgb(152, 152, 152)'
        },
        '& input[type=number]': {
            '-moz-appearance': 'textfield'
        },
        '& input[type=number]::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        },
        '& input[type=number]::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        }
    },

    checkHistory: {
        fontSize: 12,
        fontWeight: 300,
        color: 'rgb(255, 212, 40)',
        margin: theme.spacing(4, 0, 0, 0),
    },
    markDefault: {
        // position: "absolute",
        // right: "100%",
        // top: "calc(50% - 2px)",
        // transform: "translate(0, -50%)",
        display: 'flex',
        marginTop: theme.spacing(3)
    },
    saveButton: {
        fontSize: '18px',
        color: 'rgb(0, 0, 0)',
        backgroundColor: 'rgb(255, 212, 40)',
        borderRadius: '25px',
        padding: theme.spacing(1.5, 7, 1.5, 7),
        marginTop: theme.spacing(3)
    },
    actionOption: {
        width: '5%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'rgb(166, 166, 166)',
        // marginTop: theme.spacing(1.25)
    },
    loadingContainer: {
        padding: "1.6em",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    title: {
        marginBottom: 0,
        fontWeight: 500,
        fontSize: "1em",
        color: "#000",
        "& span": {
            color: "rgb(163,171,182)",
            display: "block",
            fontSize: "0.9em",
            marginTop: "5px",
        },
    },
    circularProgressSmall: {
        width: `${theme.typography.pxToRem(30)} !important`,
        height: `${theme.typography.pxToRem(30)} !important`,
    },
    licenceDetailsWrapper: {
        display: "flex",
        // justifyContent: 'space-between',
    },
    licenceExpiry: {
        //padding: theme.spacing(1.5, 1, 1.5, 1),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        margin: theme.spacing(2, 0, 0, 0),
    },
    licenceHead: {
        fontSize: 14,
        color: 'rgb(153, 164, 184)',
        fontWeight: 500,
    },
    licenceHeadRequestedBy: {
        fontSize: 14,
        color: 'rgb(153, 164, 184)',
        fontWeight: 500,
        marginLeft: '100px'
    },
    licenceHistoryContent: {
        fontSize: 14,
        color: 'rgb(0, 0, 0)',
        fontWeight: 500,
    },
    licenseItemRow: {
        cursor: 'pointer',
        paddingLeft: 12,
    },
    licenseItemRowForAddDriver: {
        paddingLeft: 12,
    },
    licenseItemRowSelected: {
        // display: 'flex',
        // alignItems: 'center',
        cursor: 'pointer',
        background: '#d4d4d4',
        height: theme.spacing(8),
        paddingLeft: 12,
        // "& div > *": {
        //     color: 'white',
        // },
    },
    rightShadowBorder: {
        boxShadow: "-2px 0px 4px 1px rgba(0, 0, 0, 0.59)",
        marginTop: '10px'
    },
    rightPanelParent: {
        width: '40%',
        marginTop: 8,
        background: "rgb(251, 251, 251)",
        boxShadow: "-5px 5px 5px -3px #9d9696",
        float: 'right'
    },
    validateLabel: {
        marginRight: '12px',
        cursor: 'pointer',
        color: 'rgb(255, 212, 40)',
        fontWeight: 412,
        background: 'unset',
        "&:hover": {
            backgroundColor: "unset",
        },

    },
    licenseCheckedBy: {
        marginTop: "16px",
        marginLeft: "100px"
    },
    buttonsContainer: {
        display: "flex"
    }
}));
